export default function GetFormattedDate(dateInInteger) {
  if (dateInInteger) {
    const date = new Date(dateInInteger * 1000)
    const mnth = ('0' + (date.getMonth() + 1)).slice(-2)
    const day = ('0' + date.getDate()).slice(-2)
    console.log(date, mnth, day, 'datedate')
    return [date.getFullYear(), mnth, day].join('-')
  }

  return null
}
